import React, { useEffect } from "react";
import Map from "../components/Map";
import FormContainer from "../components/FormContainer";
import { ListGroup, ListGroupItem, Row } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { getClinicDetails } from "../actions/clinicActions";
import Help from "../components/Help";
import {
  FaCashRegister,
  FaExternalLinkAlt,
  FaHome,
  FaListUl,
  FaShieldAlt,
  FaStethoscope,
  FaUsers,
  FaVoicemail,
  FaWhatsapp,
} from "react-icons/fa";
import { IoSettingsOutline } from "react-icons/io5";
import { CiMail } from "react-icons/ci";
import { MdAddCall, MdManageAccounts } from "react-icons/md";
import { RiNurseLine } from "react-icons/ri";

const ClinicScreen = () => {
  const params = useParams();
  const clinicId = params.clinicId;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const clinicDetails = useSelector((state) => state.clinicDetails);
  const { norequest, loading, clinic, error } = clinicDetails;

  const isAdmin =
    clinic?.members.find((m) => m.memberId?.toString() === userInfo?._id)
      ?.permissionId === "0";

  const isSecretary =
    clinic?.members.find((m) => m.memberId?.toString() === userInfo?._id)
      ?.permissionId === "3";

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (!userInfo) {
      navigate(`/login-screen?returnFrom=${location.pathname}`);
    } else {
      if (norequest || !clinic || clinic._id !== clinicId) {
        dispatch(getClinicDetails(clinicId));
      }
    }
  }, [clinicId, norequest, clinic, userInfo, navigate]);
  return (
    <FormContainer>
      {loading && (
        <>
          <Skeleton height="50px" className="mb-5" />
          <Loader />
        </>
      )}{" "}
      {error && (
        <>
          <Map
            titles={[
              {
                idx: "1",
                label: (
                  <>
                    <FaHome /> Home
                  </>
                ),
                path: `/`,
                active: false,
              },
              {
                idx: "2",
                label: `Clinic Screen`,
                path: ``,
                active: true,
              },
            ]}
          />
          <Message children={error} variant={`danger`} />
        </>
      )}
      {clinic && (
        <>
          <Map
            titles={[
              {
                idx: "1",
                label: (
                  <>
                    <FaHome /> Home
                  </>
                ),
                path: `/`,
                active: false,
              },
              {
                idx: "2",
                label: `Clinic List Screen`,
                path: `/clinic-list-screen`,
                active: false,
              },
              {
                idx: "3",
                label: `${clinic.clinicName}`,
                path: ``,
                active: true,
              },
            ]}
          />

          <h1>Members</h1>

          {/* <pre>{JSON.stringify(clinic.members, null, 2)}</pre> */}

          <ListGroup>
            {clinic.members.map((m, index) => {
              const displayName =
                m.firstName && m.lastName
                  ? `${m.firstName} ${m.lastName}`
                  : m.userEmail;

              return (
                <ListGroupItem
                  key={m._id || index}
                  variant="primary"
                  className="d-flex justify-content-between align-items-center m-2"
                >
                  <p className="mb-0">
                    <span>
                      {m.permissionId === "0" ? (
                        <MdManageAccounts />
                      ) : m.permissionId === "1" ? (
                        <FaStethoscope />
                      ) : m.permissionId === "2" ? (
                        <RiNurseLine />
                      ) : (
                        <FaCashRegister />
                      )}{" "}
                      {displayName}
                    </span>

                    <br />

                    {m.email && (
                      <>
                        <span className="ml-4">
                          <a
                            href={`mailto:${m.email}`}
                            className="text-decoration-none"
                            title="Send email"
                          >
                            <small>{m.email}</small> <CiMail />
                          </a>
                        </span>
                        <br />
                      </>
                    )}

                    {m.phone && (
                      <span className="ml-4">
                        <small>{m.phone} </small>
                        <a
                          href={`tel:${m.phone}`}
                          className="text-decoration-none mr-2"
                          title="Call"
                        >
                          <MdAddCall />
                        </a>
                        {"    "}
                        <a
                          href={`https://wa.me/${m.phone.replace(/\D/g, "")}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-success text-decoration-none"
                          title="WhatsApp"
                        >
                          <FaWhatsapp />
                        </a>
                      </span>
                    )}
                  </p>
                </ListGroupItem>
              );
            })}
          </ListGroup>
          <h1>Links</h1>

          <ListGroup style={{ color: "#00abff" }} className="mt-3">
            <ListGroupItem
              id="waitingList"
              onClick={() => {
                navigate(`/visit-list-screen/${clinicId}`);
              }}
              className="mb-2 d-flex justify-content-between align-items-center border-dark "
            >
              <h1>
                {" "}
                <FaListUl /> Waiting Visit List
              </h1>
              <h1>
                <span className="go-icon">
                  <FaExternalLinkAlt />
                </span>{" "}
                go
              </h1>
            </ListGroupItem>

            <ListGroupItem
              id="patients"
              onClick={() => {
                navigate(
                  `/patient-list-screen/${clinic.clinicOwnerId}?clinicId=${clinic._id}`,
                );
              }}
              className="mb-2 d-flex justify-content-between align-items-center border-dark"
            >
              <h1>
                <FaUsers /> Patients
              </h1>
              <h1>
                <span className="go-icon">
                  <FaExternalLinkAlt />
                </span>{" "}
                go
              </h1>
            </ListGroupItem>

            {isAdmin && (
              <ListGroupItem
                onClick={() => {
                  navigate(`/clinic-edit-screen/${clinicId}`);
                }}
                className="mb-2 d-flex justify-content-between align-items-center border-dark"
              >
                <h1>
                  <IoSettingsOutline /> Clinic Settings
                </h1>
                <h1>
                  <span className="go-icon">
                    <FaExternalLinkAlt />
                  </span>{" "}
                  go
                </h1>
              </ListGroupItem>
            )}
          </ListGroup>
        </>
      )}
      <Help />
    </FormContainer>
  );
};

export default ClinicScreen;
